jQuery( function( $ ) {

	$( document ).on( 'click', '.js_member-exclusive', function( e ) {
		e.preventDefault();

		$( '.oamm-lightbox, .oamm-lightbox-content' ).show();
	} );

} );
